import { removeLottieLoading } from "@/utils";
import { useAppDispatch, useAppSelector } from "@/utils/redux";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { Button, Layout, Result, useMessagedAsync, useMessagedAsyncFn } from "@payping/web-components";
import { useEffect, useState } from "react";
import { getPersonalInfo, getUserBank, getUserBusinessinfo, getUserLocalInformation } from "@payping/redux/actions";
import html2canvas from "html2canvas";
import { portableFetch } from "@payping/api/portableFetch";
import { webConstants } from "@payping/utils/platformConstants";
import styles from "./index.module.scss";
import Loading from "../loading";
import SignContractContract from "./Contract";
import SignContractDraw from "./Draw";

export default function SignContractPage() {
  const dispatch = useAppDispatch();
  const [showDraw, setShowDraw] = useState(false);
  const token = useAppSelector((state) => state.auth.token);

  const [image, setImage] = useState("");

  const { loading } = useMessagedAsync(async () => {
    await dispatch(getPersonalInfo());
    await dispatch(getUserBusinessinfo());
    await dispatch(getUserLocalInformation());
    await dispatch(getUserBank());
  }, [dispatch]);

  const { t } = useAppTranslation();

  useEffect(() => {
    removeLottieLoading();
  }, []);

  useEffect(() => {
    if (image) window.scrollTo(0, document.body.scrollHeight);
  }, [image]);

  const [sendRequestState, handleSendRequest] = useMessagedAsyncFn(async (formData: FormData) => {
    const fileSrc = await portableFetch(`${webConstants.BASE_URL}/filemanager/v1/Upload/Contract`, {
      body: formData,
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const text = await fileSrc.text();
    await portableFetch(`${webConstants.BASE_URL}/v1/user/SubmitContract`, {
      body: JSON.stringify({
        contractPath: text,
      }),
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        contentType: "application/json",
      },
    });
    return true;
  });

  const sendContract = async () => {
    const contractContent = document.getElementById("contract_content");
    if (!contractContent) return;
    try {
      const res = await html2canvas(contractContent);
      const formData = new FormData();
      res.toBlob(
        async (blob) => {
          if (!blob) return;
          formData.set("file", blob, "contract.jpg");

          try {
            await handleSendRequest(formData);
          } catch (e) {
            /* empty */
          }
        },
        "image/jpeg",
        100
      );
    } catch (e) {
      /* empty */
    }
  };

  if (loading) {
    return <Loading />;
  }

  if (sendRequestState.value === true) {
    return (
      <Layout className={styles.layout}>
        <Layout.Content className="relative">
          <Result status={"success"} title={t("signContract.successTitle")} />
        </Layout.Content>
      </Layout>
    );
  }

  return (
    <Layout className={styles.layout}>
      <Layout.Content className="relative">
        {showDraw ? (
          <SignContractDraw
            onFinish={(_, data) => {
              setImage(data);
              setShowDraw(false);
            }}
          />
        ) : (
          <>
            <SignContractContract issue={image} />
            <div style={{ margin: "0 auto" }} className="w-100 flex justify-center">
              {image ? (
                <Button
                  loading={sendRequestState.loading}
                  size="large"
                  type="primary"
                  className="px-4"
                  onClick={async () => {
                    await sendContract();
                  }}
                >
                  {t("signContract.done")}
                </Button>
              ) : (
                <Button
                  size="large"
                  type="primary"
                  className="px-4"
                  onClick={() => {
                    setShowDraw(true);
                  }}
                >
                  {t("signContract.sign")}
                </Button>
              )}
            </div>
          </>
        )}
      </Layout.Content>
    </Layout>
  );
}
